class XMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.current_width = window.innerWidth),
      (this.state = "closed"),
      (this.parent_links = this.querySelectorAll(".x-menu--level-1--link > a")),
      (this.sub_menu_links = this.querySelectorAll(
        '.x-menu--level-1--link:not([data-x-menu--depth="1"]) > a'
      )),
      (this.overlap_parent = parseInt(
        this.getAttribute("data-x-menu--overlap-parent")
      )),
      (this.header_root = document.querySelector(".header--root")),
      (this.sub_menu_items = []),
      (this.parents_with_sub_menu = []),
      this.sub_menu_links.forEach((e) => {
        var t = e.parentNode;
        this.parents_with_sub_menu.push(t),
          e.parentNode
            .querySelectorAll("ul a")
            .forEach((e) => this.sub_menu_items.push(e));
      }),
      this.load();
  }
  disconnectedCallback() {
    window.off("resize.XMenu"),
      this.parent_links.off("focus.XMenu"),
      this.sub_menu_links.off("touchstart.XMenu focus.XMenu"),
      this.parents_with_sub_menu.off("mouseleave.XMenu"),
      this.parents_with_sub_menu.forEach((e) => {
        e.querySelectorAll(":scope > a").off("mouseenter.XMenu");
      });
  }
  load() {
    this.arrangeMegaNav(),
      this.listeners(),
      this.checkOverlap(),
      this.resizeListeners(),
      this.transitionListeners();
  }
  listeners() {
    this.parents_with_sub_menu.forEach((e) => {
      e.querySelectorAll(":scope > a").on("mouseenter.XMenu", (e) =>
        this.slideDown(e.target)
      );
    }),
      this.parents_with_sub_menu.on("mouseleave.XMenu", () => this.slideUp()),
      this.parent_links.on("focus.XMenu", () => this.slideUp),
      this.sub_menu_links.on("focus.XMenu", (e) => this.slideDown(e.target)),
      this.sub_menu_links.on("touchstart.XMenu", (e) => {
        e.preventDefault(),
          "true" === e.target.parentNode.getAttribute("data-x-menu--open")
            ? this.slideUp(!1)
            : this.slideDown(e.target);
      });
  }
  checkOverlap() {
    if (theme.utils.isTouchDevice && "large" !== theme.mqs.current_window)
      return (
        this.setAttribute("data-x-menu--overlap", !0),
        this.header_root.setAttribute("data-x-menu--overlap", !0),
        window.trigger("theme:XMenu:loaded"),
        !1
      );
    this.setAttribute("data-x-menu--overlap", !0),
      this.header_root.setAttribute("data-x-menu--overlap", !0);
    let e = this;
    1 === this.overlap_parent
      ? (e = e.parentNode)
      : 2 === this.overlap_parent && (e = e.parentNode.parentNode);
    var t,
      n,
      s,
      i,
      r = e.parentNode,
      a = e.index();
    let o = !1,
      u = (1 < a && (o = r.children[a - 1]), !1);
    a + 1 < r.children.length && (u = r.children[a + 1]),
      o &&
        ((n =
          (t = o.querySelector(":scope > :last-child")).offset().left +
          t.offsetWidth),
        e.offset().left - 1 <= n) &&
        (this.setAttribute("data-x-menu--overlap", !0),
        this.header_root.setAttribute("data-x-menu--overlap", !0)),
      u &&
        ((i =
          (s = e.querySelector(":scope > :last-child")).offset().left +
          s.offsetWidth),
        u.offset().left - 1 <= i) &&
        (this.setAttribute("data-x-menu--overlap", !0),
        this.header_root.setAttribute("data-x-menu--overlap", !0)),
      window.trigger("theme:XMenu:loaded");
  }
  resizeListeners() {
    window.on("resize.XMenu", () => {
      this.animation_request && cancelAnimationFrame(this.animation_request),
        this.current_width !== window.innerWidth &&
          ((this.current_width = window.innerWidth),
          (this.animation_request = requestAnimationFrame(() =>
            this.checkOverlap()
          )));
    });
  }
  arrangeMegaNav() {
    if (0 === this.parents_with_sub_menu.length) return !1;
    var e = this.querySelectorAll(
      '[data-x-menu--depth="3"] .x-menu--level-2--container'
    );
    e.length &&
      e.forEach((e) => {
        var t = e.querySelectorAll('[data-x-menu--single-parent="true"]');
        if (t.length) {
          const s = theme.utils.parseHtml(
            '<div class="x-menu--single-parents"></div>'
          );
          e.prepend(s);
          var n = document.createElement("ul");
          s.appendChild(n),
            t.forEach((e) => {
              s.querySelector("ul").appendChild(e);
            });
        }
      });
  }
  slideDown(e, t = !1) {
    clearTimeout(this.timer);
    var n,
      s = e.parentNode;
    if (
      "true" === s.getAttribute("data-x-menu--open") ||
      "closing" === this.state
    )
      return !1;
    this.slideUp(!1),
      t && "complete" !== t
        ? (this.timer = setTimeout(() => this.slideDown(e, "complete"), t))
        : ((s.querySelector(".icon--chevron-up").style.display = "inline"),
          (s.querySelector(".icon--chevron-down").style.display = "none"),
          s.setAttribute("data-x-menu--open", !0),
          (n = s.querySelector(".x-menu--level-2--container")) &&
            (n.setState("forwards"), (n.style.height = "auto")),
          e.setAttribute("aria-expanded", !0),
          (this.state = "open"));
  }
  slideUp(e = 300) {
    let t = !1,
      n = !1,
      s;
    for (let r = 0; r < this.parents_with_sub_menu.length; r++)
      if (
        "true" ===
        (s = this.parents_with_sub_menu[r]).getAttribute("data-x-menu--open")
      ) {
        (n = s), (t = n.querySelector(":scope > a"));
        break;
      }
    var i;
    n &&
      (e
        ? (this.timer = setTimeout(() => this.slideUp(!1), e))
        : ((n.querySelector(".icon--chevron-up").style.display = "none"),
          (n.querySelector(".icon--chevron-down").style.display = "inline"),
          n.setAttribute("data-x-menu--open", !1),
          (i = n.querySelector(".x-menu--level-2--container")) &&
            i.setState("backwards"),
          t && t.setAttribute("aria-expanded", !1),
          (this.state = "closing")));
  }
  transitionListeners() {
    this.sub_menu_links.forEach((e) => {
      var t = e.parentNode;
      t &&
        t
          .querySelectorAll(".x-menu--level-2--container")
          .on("transition:at_start", (e) => {
            (e.target.style.height = "0"), (this.state = "closed");
          });
    });
  }
}
customElements.define("x-menu-root", XMenu);
